import {controller, target} from '@github/catalyst'

@controller
class PerformerLinksElement extends HTMLElement {
  @target list: HTMLElement
  @target template: HTMLTemplateElement

  private newCount = 0

  add(event: Event) {
    event.preventDefault()

    const fragment = this.template.content.cloneNode(true) as DocumentFragment
    // Index must be integer-like: Rails strong params drops fields_for-style
    // keys that don't match /\A-?\d+\z/.
    const index = `${Date.now()}${this.newCount++}`

    fragment.querySelectorAll<HTMLElement>('[name], [id], [for]').forEach((el) => {
      for (const attr of ['name', 'id', 'for'] as const) {
        const value = el.getAttribute(attr)
        if (value) el.setAttribute(attr, value.replace(/NEW_RECORD/g, index))
      }
    })

    this.list.appendChild(fragment)
    const added = this.list.lastElementChild
    added?.querySelector<HTMLInputElement>('input, select')?.focus()
  }

  remove(event: Event) {
    event.preventDefault()

    const button = event.currentTarget as HTMLElement
    const row = button.closest<HTMLElement>('[data-performer-links-row]')
    if (!row) return

    const destroyField = row.querySelector<HTMLInputElement>('[data-destroy-field]')
    const idField = row.querySelector<HTMLInputElement>('[data-id-field]')

    if (destroyField && idField && idField.value) {
      // Persisted record: flag for deletion and hide instead of removing.
      destroyField.value = '1'
      row.hidden = true
    } else {
      row.remove()
    }
  }
}
